export const cookieUtils = {
    set(name: string, value: string) {
      const expires = new Date();
      let minutes = 60; // 기본 60분
      // if(name === 'accessToken') minutes = 15; // accessToken 15분
      if (name === 'accessToken') minutes = 60; // TODO : 개발 환경용 임시로 accessToken 60분으로 설정
      expires.setTime(expires.getTime() + minutes * 60 * 1000); // minutes 후 만료
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
    },
  
    get(name: string): string | null {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim(); // Trim both leading and trailing whitespace
        if (c.indexOf(nameEQ) === 0) {
          const value = c.substring(nameEQ.length).trim(); // Also trim the value
          return value === '' ? null : value; // Return null for empty values
        }
      }
      return null;
    },
  
    remove(name: string) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
    },
  
    // 모든 쿠키 삭제
    clearAll() {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
        if (name) {
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
        }
      }
    }
  };